<template>
    <TextReading ref="textReading"
                 :article-detail="detail"
                 :collect-handler="collect"
                 :collect-status="detail.follow_state === '1'"
                 :chapter-change-handler="chapter"
                 :limit-id="limitId"
    >
        <div class="nav-wrap">
            <div class="subscribe-card-wrap">
                <div class="subscribe-card">
                    <div v-if="menuList[0]" class="infos">
                        <h4 class="text1line">
                            {{ langTransfer(baseData.name) }}
                        </h4>
                        <h5 class="text1line" @click="goDetailPage">
                            {{ langTransfer(menuList[0]?menuList[0].author_name: '') }}
                        </h5>
                    </div>
                    <div class="cover hb-resource-cover">
                        <img v-if="detail.author_poster"
                             :src="detail.author_poster"
                        >
                    </div>
                </div>
                <div v-show="webInfo.isAllowLogin=='1' && menuList[0]"
                     class="subscribe-btn-wrap lr-img-scale"
                     @click="addFocus"
                >
                    <LottieSubscribeBtn :is-collection="isCollection" />
                </div>
            </div>
            <div class="catelog-mask">
                <h5>{{ langTransfer('目录') }}</h5>
                <bscroll-view hide-scroll-bar :pull-up-handler="loadMore">
                    <div class="catelog-list">
                        <div v-for="(item, index) in menuList"
                             :key="index"
                             class="cate-item"
                             :style="{'font-weight': $route.params.id === item.unique_code ? '600' :'',
                                      color: $route.params.id === item.unique_code ? '#303133' :''}"
                             @click="subCateClick(item.unique_code)"
                        >
                            {{ langTransfer(item.title) }}
                        </div>
                    </div>
                </bscroll-view>
            </div>
        </div>
    </TextReading>
</template>
<script>
    import {
        getKonwledgeArticle, isCollection, getAuthorArticleList, getKonwledgeList
    } from '@/api/hb'
    import TextReading from '@/components/textReading'
    import LottieSubscribeBtn from '@/components/lottieActions/subscribe'
    import BscrollView from '@/components/bscrollView'

    export default {
        name: 'LevelFourCatalog',
        components: {
            TextReading,
            LottieSubscribeBtn,
            BscrollView,
        },
        data () {
            return {
                detail: {},
                getAll: false,
                menuList: [],
                limitId: {
                    start: '',
                    end: ''
                },
                currentId: '',
                isCollection: undefined,
                baseData: {}
            }
        },
        computed: {
            pageSetup () {
                return this.$store.state.pageSetup
            },
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            webInfo () {
                return this.$store.state.webInfo
            }
        },
        watch: {
            webInfo (newVal) {
                if (newVal.service_code) {
                    this.getDetail()
                }
            }
        },
        mounted () {
        },
        methods: {
            goDetailPage () {
                const { detail, $route } = this
                const { secParentId: id } = $route.params
                this.$router.push({
                    name: 'knowledgeLibDetail',
                    params: {
                        id,
                        subId: detail.author_unique_code
                    }
                })
            },
            async getKonwledgeDetail () {
                try {
                    const { webInfo, $route } = this
                    const data = await getKonwledgeList({
                        service_code: webInfo.service_code,
                        tag: 6,
                        parent_code: $route.params.secParentId
                    })
                    this.baseData = data
                } catch (err) {
                    console.log(err)
                }
            },
            addFocus () {
                const formData = {
                    type: 3,
                    res_code: this.menuList[0].author_unique_code
                }
                const callback = (bool) => {
                    if (bool) {
                        this.isCollection = false
                    } else {
                        this.isCollection = true
                    }
                }
                this.$utils.userCollect(formData, callback)
            },
            async getIsCollection () {
                try {
                    const { webInfo, detail, user_unique_code } = this
                    const data = await isCollection({
                        service_code: webInfo.service_code,
                        type: 3,
                        res_code: detail.author_unique_code,
                        user_unique_code
                    })
                    const { follow_state } = data
                    if (data) {
                        this.isCollection = Number(follow_state) === 1
                    }
                } catch (err) {
                    console.log(err)
                }
            },
            chapter (isPrev) {
                const { menuList, getAll } = this
                const { id } = this.$route.params
                let newItem
                const currentIndex = menuList.findIndex((e) => {
                    return e.unique_code === id
                })
                if (currentIndex === menuList.length - 2 && !getAll) {
                    this.loadMore()
                }
                if (isPrev) {
                    newItem = menuList[currentIndex - 1]
                } else {
                    newItem = menuList[currentIndex + 1]
                }
                if (!newItem) {
                    return
                }
                const { unique_code } = newItem
                this.subCateClick(unique_code)
            },
            subCateClick (id) {
                this.$router.push({
                    params: {
                        id
                    }
                })
            },
            async getDetail (id) {
                try {
                    const { webInfo, $route, user_unique_code } = this
                    const data = await getKonwledgeArticle({
                        service_code: webInfo.service_code,
                        type: 6,
                        id: id || $route.params.id,
                        user_unique_code
                    })
                    this.detail = data
                    if (!this.menuList[0]) {
                        this.getCatelog()
                    }
                    this.getIsCollection()
                } catch (err) {
                    console.log(err)
                }
            },
            loadMore (bscrollObj) {
                if (this.getAll) {
                    return
                }
                const newPage = Math.ceil(this.menuList.length / 15) + 1
                this.getCatelog(newPage, bscrollObj)
            },
            async getCatelog (page = 1, bscrollObj) {
                try {
                    const { webInfo, detail } = this
                    const data = await getAuthorArticleList({
                        service_code: webInfo.service_code,
                        author_unique_code: detail.author_unique_code,
                        page,
                        pageSize: 15
                    })
                    if (data.length < 15) {
                        this.getAll = true
                    }
                    if (page !== 1) {
                        this.menuList = this.menuList.concat(data)
                        this.setLimitId()
                        if (bscrollObj) {
                            bscrollObj.finishPullUp()
                        }
                        return
                    }
                    this.menuList = data
                    this.setLimitId()
                } catch (err) {
                    if (err.code === '-1') {
                        this.getAll = true
                    }
                    console.log(err)
                }
            },
            setLimitId () {
                const { menuList, getAll } = this
                this.limitId = {
                    start: menuList[0].unique_code,
                    end: getAll ? menuList[menuList.length - 1].unique_code : -1
                }
                if (getAll) {
                    return
                }

                const { id } = this.$route.params
                const hasCurrent = menuList.findIndex((e) => {
                    return e.unique_code === id
                }) !== -1
                if (!hasCurrent) {
                    this.loadMore()
                }
            },
            collect () {
                const formData = {
                    type: 1,
                    res_code: this.$route.params.id
                }
                const callback = (bool) => {
                    if (bool) {
                        this.detail.follow_state = '2'
                    } else {
                        this.detail.follow_state = '1'
                    }
                }
                this.$utils.userCollect(formData, callback)
            }
        },
        beforeRouteUpdate (to, from, next) {
            const { id } = to.params
            this.getDetail(id)
            const { contentBScrollObj } = this.$refs.textReading
            if (contentBScrollObj) {
                contentBScrollObj.finishPullUp()
                contentBScrollObj.scrollTo(0, 0)
            }
            next()
        },
        beforeRouteEnter: (to, from, next) => {
            next((vm) => {
                const { service_code } = vm.webInfo
                if (service_code) {
                    vm.getDetail()
                    vm.getKonwledgeDetail()
                }
            })
        }
    }
</script>

<style scoped lang="less">
    .nav-wrap {
        width: 100%;
        height: 100%;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }

    .subscribe-card-wrap {
        width: 300px;
        height: 172px;
        box-sizing: border-box;
        padding: 20px;
        background: #F5F7FA;
        border-radius: 8px 8px 0px 0px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .subscribe-card {
        width: 100%;
        height: 64px;
        flex-shrink: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .infos {
            flex: 1;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;

            h4 {
                width: 100%;
                font-size: 13px;
                font-family: AlibabaPuHuiTiR;
                color: #909399;
                line-height: 20px;
                font-weight: 500;
                user-select: none;
            }

            h5 {
                width: 100%;
                font-size: 24px;
                font-family: AlibabaPuHuiTiM;
                color: #303133;
                line-height: 24px;
                margin-top: 4px;
                cursor: pointer;
            }
        }

        .cover {
            width: 64px;
            height: 64px;
            box-sizing: border-box;
            border-radius: 50%;
            cursor: auto;
            margin-left: 20px;
            border: 1px solid #f7f7f7;
        }
    }

    .subscribe-btn-wrap {
        width: 100%;
        height: 48px;
        overflow: hidden;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        user-select: none;
    }

    .catelog-mask {
        width: 100%;
        flex: 1;
        overflow: hidden;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        h5 {
            padding: 10px 20px;
            margin-bottom: 15px;
            font-size: 16px;
            font-family: AlibabaPuHuiTiB;
            color: #303133;
            line-height: 16px;
            background: #FFFFFF;
            box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
            position: relative;

            &::before {
                content: "";
                display: block;
                width: 94px;
                height: 4px;
                background: #F0F2F5;
                position: absolute;
                top: 50%;
                left: -94px;
                margin-top: -2px;
            }

            &::after {
                content: "";
                display: block;
                width: 94px;
                height: 4px;
                background: #F0F2F5;
                position: absolute;
                top: 50%;
                right: -94px;
                margin-top: -2px;
            }
        }
    }

    .catelog-list {
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px 30px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        .cate-item {
            width: 100%;
            padding: 10px 0;
            font-size: 14px;
            font-family: AlibabaPuHuiTiR;
            color: #606266;
            line-height: 20px;
            border-bottom: 1px solid #f1f1f1;
            cursor: pointer;
            user-select: none;

            &:first-child {
                padding-top: 0;
            }

            &:last-child {
                border-bottom: none;
            }

            &:hover {
                color: #303133;
            }
        }
    }

</style>
